import { render, staticRenderFns } from "./WebReport.vue?vue&type=template&id=12707d57&scoped=true"
import script from "./WebReport.vue?vue&type=script&lang=js"
export * from "./WebReport.vue?vue&type=script&lang=js"
import style0 from "./WebReport.vue?vue&type=style&index=0&id=12707d57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12707d57",
  null
  
)

export default component.exports